import axios from 'axios';
import Image from 'next/image';
import { useEffect, useState } from 'react';
import AlertDialog from '../Utils/AlertDialog';


const Password = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState("");
  const [open, setOpen] = useState(false);

  const handlePassword = async () => {
    try {
      const response = await axios.post("/api/password", {email: email});

      return response.data;
    } catch (error: any) {
      return error.response.data
    }
  }

  const processPassword = async () => {
    if (email.length === 0) {
      setMessage("Please enter your email!");
    } else {
      handlePassword()
        .then((response) => {
          if (response.status === 'ok') {
            setMessage("A new password will be sent via email, please check your email");
            setEmail("");
          } else {
            switch (response.error) {
              case "cannot found user":
                setMessage("Please check again your email");
                break;

              default:
                setMessage("There's an error. Please try again.");
            }
          }
        });
    }
  }

  useEffect(() => {
    if (message !== "") {
      setOpen(true);
    }
  }, [message]);

  useEffect(() => {
    if (!open) {
      setMessage("");
    }
  }, [open]);

  return (
    <div className="w-full grid gird-cols-1 md:grid-cols-2 gap-12 md:items-center mb-[69px] md:mb-0">
      <div className="hidden w-full md:block">
        <Image
          src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/login-desktop.jpg"}
          alt="login image"
          width={900}
          height={921}
          quality={100}
        />
      </div>
      <div className="w-full md:hidden">
        <Image
          src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/login-mobile.jpg"}
          alt="login image"
          width={600}
          height={400}
          quality={100}
        />
      </div>
      <div className="mx-[35px] md:mx-auto md:w-[400px] font-dmsans">
        <h1 className="text-[24px] md:text-[32px] leading-none font-bold text-[#2C3E2F] text-center md:text-left w-full">Reset your password</h1>
        <p className="text-sm font-normal text-[#2C3E2F] mt-6 text-center md:text-left w-full">We will send you an email to reset your password.</p>
        <input
          type="text"
          name="email"
          value={email}
          placeholder="Email"
          className="w-full py-4 px-8 mt-6 text-sm placeholder:text-[#C6C6C6] border border-[#C6C6C6]"
          onChange={event => setEmail(event.target.value)}
        />
        <button
          className="bg-[#A6CAA6] w-full text-white text-base font-medium py-4 px-12 text-center mt-6"
          onClick={processPassword}
        >
          Submit
        </button>
      </div>
      <AlertDialog message={message} open={open} setOpen={setOpen} />
    </div>
  )
}

export default Password
